import { initSwiperLarge } from '../../Swiper/SwiperConfig';
import { CreateSliderContent } from '../Slider';
import { tracking_eecPromotionview } from '../../Tracking/GoogleTracking';
import { mapTrboResponseToProduktkarussellModel } from './TrboResponseMapper';
import { buildTrboRequestUrl } from './TrboRequestBuilder';

declare var __ucCmp: any;

const trboId = 'ryxCCtrEX';
const gtmId = 'BJ59EidsWQ';
const MAX_RETRIES = 50;

export async function renderTrboLastSeenSlider(slotName: string): Promise<void> {
    if (document.getElementById('productTrboLastSeen') === null) {
        return;
    }

    let ucCmpRetries = 0;
    while (window['__ucCmp'] === undefined || (await __ucCmp.isInitialized()) == false) {
        if (ucCmpRetries >= MAX_RETRIES) {
            $('.trboLastSeen').addClass('hide');
            return;
        }
        ucCmpRetries++;
        await new Promise(resolve => setTimeout(resolve, 200));
    }

    const details = await __ucCmp.getConsentDetails();
    const trboAllowed = details.services[trboId].consent.given;
    const gtmAllowed = details.services[gtmId].consent.given;
    const getTrboProducts = trboAllowed && gtmAllowed;

    if (!getTrboProducts) {
        $('.trboLastSeen').addClass('hide');
        return;
    }

    let trboRetries = 0;
    while (window['_trbo'] === undefined) {
        if (trboRetries >= MAX_RETRIES) {
            $('.trboLastSeen').addClass('hide');
            return;
        }
        trboRetries++;
        await new Promise(resolve => setTimeout(resolve, 100));
    }

    try {
        $('.trboLastSeen').removeClass('hide');
        const requestUrl = buildTrboRequestUrl(slotName);
        $.ajax({
            method: 'GET',
            dataType: 'JSON',
            url: encodeURI(requestUrl),
            success: async data => {
                var trboProducts = mapTrboResponseToProduktkarussellModel(data);
                if (trboProducts.karussellItems.length > 0) {
                    CreateSliderContent(
                        trboProducts,
                        $('#productTrboLastSeen'),
                        $('#ProduktdetailPrototypes #SliderPrototypes'),
                        'productTrboLastSeen',
                        false
                    );
                    //Karussell muss neu initialisiert werden, da der Inhalt bei Document.ready noch nicht verfügbar ist.
                    let trboslider = initSwiperLarge($('#produktkarussellLargeTrboLastSeen'));
                    await tracking_eecPromotionview();

                    trboslider.update();
                    setTimeout(function() {
                        // nasty hack aber keinen weg gefunden das karussell auf seite 1 springt...
                        $('.trboLastSeen .swiper-pagination-bullet')
                            .first()
                            .click();
                    }, 100);
                } else {
                    $('.trboLastSeen').addClass('hide');
                }
            },
            error: () => {
                $('.trboLastSeen').addClass('hide');
            },
        });
    } catch {}
}
